import { useState, useRef, useEffect } from 'react';

const useIntersect = ({ root = null, rootMargin = "0px", threshold = 0 }) => {
    const [entry, updateEntry] = useState();
    const [node, setNode] = useState(null);
    const observer = useRef(null);
    useEffect(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new window.IntersectionObserver(([entry]) => updateEntry(entry), {
            root,
            rootMargin,
            threshold
        });
        const { current: currentObserver } = observer;
        currentObserver.disconnect();
        if (node)
            currentObserver.observe(node);
        return () => currentObserver.disconnect();
    }, [node]);
    return { setNode, entry };
};

export { useIntersect };
//# sourceMappingURL=useIntersect.js.map
